import { useSelector } from 'react-redux';

import { IS_PROMO_FLOW } from 'config/envVariable';

import useIsContestUgcModule from 'client/game_photoContest/hooks/useIsContestUgcModule';

export function useSecondaryPromoSelector(selector = () => {}) {
    const isContestUgcModule = useIsContestUgcModule();
    const rootSelector = (() => {
        if (IS_PROMO_FLOW) {
            return s => s;
        } else {
            return isContestUgcModule ? s => s.relatedTwinsPromo : s => s;
        }
    })();

    return useSelector(s => selector(rootSelector(s) ?? {}));
}

export function usePrimaryPromoSelector(selector = () => {}) {
    const isContestUgcModule = useIsContestUgcModule();
    const rootSelector = (() => {
        if (IS_PROMO_FLOW) {
            return isContestUgcModule ? s => s.relatedTwinsPromo : s => s;
        } else {
            return s => s;
        }
    })();

    return useSelector(s => selector(rootSelector(s) ?? {}));
}
